// Fondo y encabezado de las pantallas sin sesión (entrar, crear contraseña).
// Foto de la iglesia en gris y oscurecida detrás del formulario, como el portal de proyectos.
const FONDO = `${process.env.PUBLIC_URL}/fondo-ingreso.jpg`;

function PantallaEntrada({ children }) {
  return (
    <div className="relative isolate flex min-h-screen flex-col items-center justify-center overflow-hidden bg-black px-4 py-12">
      <div className="absolute inset-0 -z-10" aria-hidden="true">
        <img src={FONDO} alt="" className="h-full w-full object-cover opacity-30 grayscale" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/80 to-black" />
      </div>

      <header className="mb-10 text-center">
        <span className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full border border-white/25 bg-zinc-900/80 text-2xl font-black tracking-tighter text-white" aria-hidden="true">
          MC
        </span>
        <h1 className="text-6xl font-black tracking-tighter text-white sm:text-7xl">Mi Casa</h1>
        <div className="mx-auto my-5 h-1 w-24 bg-white" />
        <p className="text-sm font-light uppercase tracking-[0.35em] text-white/90 sm:text-base">La familia que buscabas</p>
        <p className="mt-4 text-xs font-bold uppercase tracking-[0.3em] text-gray-400">Sistema de gestión</p>
      </header>

      {children}
    </div>
  );
}

export function Alerta({ children, tipo = "error" }) {
  const estilo = tipo === "error"
    ? "border-rose-500/30 bg-rose-500/10 text-rose-200"
    : "border-emerald-500/30 bg-emerald-500/10 text-emerald-200";
  return (
    <div role={tipo === "error" ? "alert" : "status"} className={`mb-5 rounded-xl border p-3 text-sm ${estilo}`}>
      {children}
    </div>
  );
}

export function CampoContrasena({ id, etiqueta, valor, onCambio, autoComplete, deshabilitado, autoFocus }) {
  return (
    <div className="mb-5">
      <label htmlFor={id} className="etiqueta">{etiqueta}</label>
      <input id={id} type="password" value={valor} onChange={(e) => onCambio(e.target.value)} className="campo"
        autoComplete={autoComplete} disabled={deshabilitado} autoFocus={autoFocus} />
    </div>
  );
}

export default PantallaEntrada;
